module.exports = __webpack_public_path__ + "static/media/crossmodimage-opt.ec308ab1.webp";